var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/modals/slider/carousel.html',
    '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n' +
    '    <div class="carousel-inner" ng-transclude></div>\n' +
    '    <button class="arrow-left" ng-click="prev()" ng-show="slides.length > 1"></button>\n' +
    '    <button class="arrow-right" ng-click="next()" ng-show="slides.length > 1"></button>\n' +
    '</div>');
}]);

module.exports = "/modals/slider/carousel.html";